/** Human-readable page titles for GA `page_title` / `page_name`. */
export function pageName(pathname: string): string {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/login') return 'Login';
  if (path === '/') return 'Home';
  if (path === '/tearsheets') return 'Tearsheets — Reports';
  if (path === '/tearsheets/create') return 'Tearsheets — Create';
  if (path === '/tearsheets/builder') return 'Tearsheets — Builder';
  if (path === '/tearsheets/branding') return 'Tearsheets — Branding';
  if (path.startsWith('/tearsheets/view')) return 'Tearsheets — View';
  if (path === '/admin/company') return 'Admin — My company';
  if (path.startsWith('/admin')) return 'Admin';
  if (path.startsWith('/settings')) return 'Settings';
  if (path.startsWith('/tearsheets')) return 'Tearsheets';
  if (path === '/oms/create') return 'OMS — Create Order';
  if (path === '/oms/pretrade') return 'OMS — PreTrade Compliance';
  if (path === '/oms/monitor') return 'OMS — Order Monitor';
  if (path === '/oms/post-trade') return 'OMS — Post Trade Compliance';
  if (path === '/oms/blotter') return 'OMS — Trade Blotter';
  if (path === '/oms/custom') return 'OMS — Custom layout';
  if (path.startsWith('/oms')) return 'OMS';
  return 'HedgeFacts Cloud';
}
